<script>
  export let close;
  export let useAbsolutePosition = true; // Default to true
  export let color = "#fff";
  export let marginBottom = "1rem";

  import i18n from "./i18n/i18n";

  addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      close();
    }
  });

  // Reactive statement to determine the class for positioning
  $: positionClass = useAbsolutePosition ? "close-position" : "close-relative";
</script>

<button
  class={`close ${positionClass}`}
  on:click={close}
  aria-label={$i18n.t('tour.closeButton')}
  style="
    --close-color: {color};
    --close-margin-bottom: {marginBottom};
  "
>
  <div class="close-container">
    <div class="leftright"></div>
    <div class="rightleft"></div>
    <span class="label">{$i18n.t('tour.closeButton')}</span>
  </div>
</button>

<style>
  .close {
    appearance: none;
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    text-align: inherit;
    /* outline-color: var(--close-color); */
  }

  .close-container {
    position: relative;
    margin: auto;
    width: 50px;
    height: 50px;
    cursor: pointer;
    margin-bottom: var(--close-margin-bottom);
  }

  .leftright,
  .rightleft {
    height: 4px;
    width: 50px;
    position: absolute;
    margin-top: 24px;
    background-color: var(--close-color);
    border-radius: 2px;
    transition: all 0.3s ease-in;
  }

  .leftright {
    transform: rotate(45deg);
  }

  .rightleft {
    transform: rotate(-45deg);
  }

  .label {
    color: var(--close-color);
    font-family: Helvetica, Arial, sans-serif;
    font-size: 0.6em;
    text-transform: uppercase;
    letter-spacing: 2px;
    transition: all 0.3s ease-in;
    opacity: 0;
    position: absolute;
    margin: 60px 0 0 0px;
    width: 100%;
    text-align: center;
  }

  .close-container:hover .leftright {
    transform: rotate(-45deg);
    background-color: var(--close-color);
  }

  .close-container:hover .rightleft {
    transform: rotate(45deg);
    background-color: var(--close-color);
  }

  .close-container:hover .label {
    opacity: 1;
  }

  .close-position {
    position: absolute;
    z-index: 9999;
    right: 20px;
    top: 20px;
  }

  .close-relative {
    position: relative;
    z-index: 9999;
  }
</style>
